import { Routes } from '@angular/router';
import { BookingDispatcher } from './components/booking/booking-dispatcher/booking-dispatcher.component';
import { AppHeader } from './components/app-header/app-header.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', component: BookingDispatcher },
  {
    path: 'postal-code',
    loadComponent: () =>
      import('./components/booking/open-booking/open-booking.component').then((m) => m.OpenBooking),
  },
    {
    path: 'select-meeting',
    loadComponent: () =>
      import('./components/booking/open-booking/open-booking.component').then((m) => m.OpenBooking),
  },
    {
    path: 'address',
    loadComponent: () =>
      import('./components/booking/open-booking/open-booking.component').then((m) => m.OpenBooking),
  },
  {
    path: 'create',
    loadComponent: () =>
      import('./components/booking/create-booking/create-booking.component').then(
        (m) => m.CreateBooking,
      ),
    data: { complete: false },
  },
  {
    path: 'complete',
    loadComponent: () =>
      import('./components/booking/create-booking/create-booking.component').then(
        (m) => m.CreateBooking,
      ),
    data: { complete: true },
  },
    {
    path: 'contact-me',
    loadComponent: () =>
      import('./components/booking/contact-me/contact-me.component').then(
        (m) => m.ContactMe,
      ),
    data: { complete: true },
  },

  { path: 'error', loadComponent: () => import('./components/error-page/error.component').then(m => m.ErrorComponent) },
];
